// recipe-cwd-resolved-against-repo-root.ts
//
// One rule for every recipe the controller spawns (ticket verification AND
// release deploy/smoke): a relative `cwd` is authored relative to the
// execution repo — the mission worktree — never to whatever directory
// `avatar autopilot run` happened to be started from. Before this module the
// ticket path resolved it (supervisor-attempt-verify-input.ts) and the release
// path did not, so `cwd: "."` deployed from the operator's shell directory
// (dogfood Beta 9, F2, 2026-09-30).
import { isAbsolute, join } from "node:path";

export function resolveRecipeCwdAgainstRepoRoot<T extends { cwd: string }>(
  recipe: T,
  repoRoot: string,
): T {
  return { ...recipe, cwd: isAbsolute(recipe.cwd) ? recipe.cwd : join(repoRoot, recipe.cwd) };
}
